import { useEffect, useRef, useState } from "react";
import { TextField } from "@mui/material";
import axios from "axios";
import { GoPencil } from "react-icons/go";
import { Formik } from "formik";
import { Form, Field } from "formik";
import * as Yup from "yup";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import { Bounce, toast } from "react-toastify";

const validationSchema2 = Yup.object().shape({
  title: Yup.string().required("Title is required"),
  description: Yup.string().test(
    "richTextRequired",
    "Policy is required",
    function (value) {
      if (!value) return false;
      const parser = new DOMParser();
      const doc = parser.parseFromString(value, "text/html");
      const cleanText = doc.body.textContent || "";
      return cleanText.trim().length > 0;
    }
  ),
  principles: Yup.array().of(
    Yup.object().shape({
      title: Yup.string().required("Principle title is required"),
    })
  ),
});
const Section2Schema = Yup.object().shape({
  title1: Yup.string().required("Title 1 is required"),
  title2: Yup.string().required("Title 2 is required"),
  description: Yup.string().required("Description is required"),
});

const About = () => {
  const [res, setRes] = useState({});
  const [editMode, setEditMode] = useState(false);
  const [editSection1, setEditSection1] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [section2ImageFile, setSection2ImageFile] = useState(null);
  const [section2ImagePreview, setSection2ImagePreview] = useState("");
  const section2FileInputRef = useRef(null);
  const [principleImages, setPrincipleImages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [heroVideo, setHeroVideo] = useState("");
  const [heroVideoPreview, setHeroVideoPreview] = useState("");
  const token = localStorage.getItem("hiedberg_admin_token");
  const [story, setStory] = useState("");

  const fetchData = async () => {
    try {
      setLoading(true);
      const result = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/about/get`
      );
      setStory(result.data.data.section1.description || "");
      setRes(result.data.data);
      setSection2ImagePreview(`${result.data.data.section2?.imageUrl}`);
    } catch (error) {
      toast.error(error, {
        position: "top-right",
        autoClose: 5000,
        pauseOnHover: true,
        transition: Bounce,
      });
      console.error("Error fetching item shop:", error);
    } finally {
      setLoading(false);
    }
  };
  const handleSection2ImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const previewURL = URL.createObjectURL(file);
      setSection2ImagePreview(previewURL);
      setSection2ImageFile(file);
    }
  };
  const handleImageChange = (e, index) => {
    const file = e.target.files[0];
    if (file) {
      const previewURL = URL.createObjectURL(file);
      const updatedImages = [...principleImages];
      updatedImages[index] = { file, preview: previewURL };
      setPrincipleImages(updatedImages);
    }
  };
  const handleVideoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const videoUrl = URL.createObjectURL(file);
      setHeroVideo(file);
      setHeroVideoPreview(videoUrl);
    }
  };

  console.log(res);

  const initialValues = {
    title1: res?.hero?.title1 || "",
    title2: res?.hero?.title2 || "",
    description: res?.hero?.description || "",
    buttonText: res?.hero?.buttonText || "",
    companyDetails: res?.hero?.companyDetails?.map((item) => ({
      title: item.title || "",
      value: item.value || "",
    })) || [{ title: "", value: "" }],
    videoUrl: res.hero?.videoUrl || "",
  };
  const validationSchema = Yup.object().shape({
    title1: Yup.string().required("Required"),
    title2: Yup.string().required("Required"),
    description: Yup.string().required("Required"),
    buttonText: Yup.string().required("Required"),
    companyDetails: Yup.array().of(
      Yup.object().shape({
        title: Yup.string().required("Title required"),
        value: Yup.string().required("Value required"),
      })
    ),
    videoUrl: Yup.string().url("Please add http or https in URL"),
  });
  const initialValues2 = {
    title: res.section1?.title || "",
    description: story || "",
    principles:
      res.section1?.principles?.map((p) => ({
        title: p.title || "",
        imageUrl: p.imageUrl || "",
      })) || [],
  };
  const handleSubmit2 = async (values) => {
    try {
      setLoading(true);
      console.log("Form values:", values);
      console.log("Selected file:", section2ImageFile);

      let imageUrl = res?.section2?.imageUrl || "";

      let filePath = "";
      if (section2ImageFile) {
        const formData = new FormData();
        formData.append("file", section2ImageFile);

        const uploadRes = await axios.post(
          `${process.env.REACT_APP_BASE_URL}/upload`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        console.log("Upload response full:", uploadRes);
        filePath = uploadRes?.data?.data?.publicUrl;

        if (!filePath) {
          throw new Error("Image upload failed: No filePath returned");
        }
        const imageUrl = `${process.env.REACT_APP_BASE_URL}/${filePath}`;
        if (!imageUrl) {
          throw new Error("Image upload failed: No URL returned");
        }
      }
      const payload = {
        section2: {
          title1: values.title1,
          title2: values.title2,
          description: values.description,
          imageUrl: filePath || imageUrl,
        },
      };
      console.log("Final payload:", payload.section2);

      const updateRes = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/about/update`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log("Section 2 updated successfully:", updateRes.data);
      fetchData();
      setIsEditing(false);
      setSection2ImageFile(null);
      toast.success("Section 2 updated successfully", {
        position: "top-right",
        autoClose: 5000,
        pauseOnHover: true,
        transition: Bounce,
      });
    } catch (error) {
      toast.error(error, {
        position: "top-right",
        autoClose: 5000,
        pauseOnHover: true,
        transition: Bounce,
      });
      if (error.response) {
        console.error("Update failed:", {
          status: error.response.status,
          data: error.response.data,
        });
      } else if (error.request) {
        console.error("No response received:", error.request);
      } else {
        console.error("Error setting up request:", error.message);
      }
    } finally {
      setLoading(false);
    }
  };
  const handleSubmitHero = async (values) => {
    try {
      setLoading(true);
      let uploadedVideoUrl = res.hero?.videoUrl || "";
      if (heroVideo) {
        const formData = new FormData();
        formData.append("file", heroVideo);
        const uploadRes = await axios.post(
          `${process.env.REACT_APP_BASE_URL}/upload`,
          formData
        );
        uploadedVideoUrl = uploadRes.data.data.publicUrl;
      }
      const payload = {
        hero: {
          title1: values.title1,
          title2: values.title2,
          description: values.description,
          buttonText: values.buttonText,
          companyDetails: values.companyDetails,
          videoUrl: uploadedVideoUrl,
        },
      };

      await axios.post(
        `${process.env.REACT_APP_BASE_URL}/about/update`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      fetchData();
      console.log("Hero section updated");
      setEditMode(false);
      toast.success("Hero section updated successfully", {
        position: "top-right",
        autoClose: 5000,
        pauseOnHover: true,
        transition: Bounce,
      });
    } catch (err) {
      toast.error(err, {
        position: "top-right",
        autoClose: 5000,
        pauseOnHover: true,
        transition: Bounce,
      });
      console.error("Hero update failed:", err);
    } finally {
      setLoading(false);
    }
  };
  const handleSubmitSection1 = async (values) => {
    try {
      setLoading(true);

      const updatedPrinciples = await Promise.all(
        values.principles.map(async (item, index) => {
          let imageUrl = res.section1?.principles?.[index]?.imageUrl || "";

          // Upload only if new image exists for this index
          if (
            principleImages &&
            principleImages[index] &&
            principleImages[index].file
          ) {
            const formData = new FormData();
            formData.append("file", principleImages[index].file);
            const uploadRes = await axios.post(
              `${process.env.REACT_APP_BASE_URL}/upload`,
              formData,
              {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              }
            );
            imageUrl = uploadRes.data.data.publicUrl; // or .filePath whichever your API returns
          }

          // Still allow old image if no new upload
          if (!imageUrl) {
            throw new Error(`Image missing for principle at index ${index}`);
          }

          return {
            title: item.title,
            imageUrl,
          };
        })
      );

      const payload = {
        section1: {
          title: values.title,
          description: story,
          principles: updatedPrinciples,
        },
      };

      await axios.post(
        `${process.env.REACT_APP_BASE_URL}/about/update`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      fetchData();
      console.log("Section 1 updated successfully");
      setEditSection1(false);
      toast.success("Section 1 updated successfully", {
        position: "top-right",
        autoClose: 5000,
        pauseOnHover: true,
        transition: Bounce,
      });
    } catch (err) {
      toast.error(err, {
        position: "top-right",
        autoClose: 5000,
        pauseOnHover: true,
        transition: Bounce,
      });
      console.error("Section 1 update failed:", err);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);
  return (
    <>
      {loading ? (
        <div className="flex justify-center py-10">
          <div className="h-6 w-6 animate-spin rounded-full border-t-2 border-blue-500"></div>
        </div>
      ) : (
        <div className="mt-5 space-y-4 overflow-auto pb-6">
          <div className="rounded-xl border border-gray-300 bg-white p-4 shadow-sm">
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              enableReinitialize
              onSubmit={handleSubmitHero}
            >
              {({ errors, touched, resetForm, values }) => (
                <Form>
                  <div className="mb-4 flex items-center justify-between">
                    <h3 className="text-lg font-semibold text-gray-800">
                      Hero Section
                    </h3>
                    {editMode ? (
                      <div className="flex items-center gap-3">
                        <button
                          type="submit"
                          className="text-sm font-medium text-blue-600 hover:text-blue-800"
                        >
                          Save Changes
                        </button>
                        <button
                          type="button"
                          onClick={() => {
                            setEditMode(false);
                            resetForm();
                          }}
                          className="text-sm font-medium text-gray-500 hover:text-gray-700"
                        >
                          Cancel
                        </button>
                      </div>
                    ) : (
                      <GoPencil
                        className="hover:text-black h-5 w-5 cursor-pointer"
                        onClick={() => setEditMode(true)}
                      />
                    )}
                  </div>
                  <div className="rounded-xl border border-gray-300 bg-white p-4 shadow-sm">
                    <h3 className="mb-4 text-lg font-semibold text-gray-800">
                      Hero Video
                    </h3>
                    <div className="flex flex-col gap-4">
                      <div className="group relative h-64 w-full overflow-hidden rounded-lg border border-gray-300">
                        {heroVideoPreview || res.hero?.videoUrl ? (
                          <video
                            src={heroVideoPreview || res.hero?.videoUrl}
                            className="h-full w-full object-cover"
                            controls
                            muted
                            autoPlay
                          />
                        ) : (
                          <div className="flex h-full w-full items-center justify-center bg-gray-100">
                            <span className="text-gray-500">
                              No video uploaded
                            </span>
                          </div>
                        )}
                        {editMode && (
                          <>
                            <div className="bg-green absolute inset-0 flex items-center justify-center bg-[#353935] bg-opacity-65 opacity-0 transition duration-300 group-hover:opacity-100">
                              <GoPencil
                                className="h-7 w-7 cursor-pointer text-white"
                                onClick={() =>
                                  document
                                    .getElementById("heroVideoInput")
                                    .click()
                                }
                              />
                            </div>
                            <input
                              type="file"
                              id="heroVideoInput"
                              accept="video/*"
                              className="hidden"
                              onChange={handleVideoChange}
                            />
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-col gap-y-4">
                    <Field
                      as={TextField}
                      name="title1"
                      label="Title 1"
                      variant="outlined"
                      size="small"
                      fullWidth
                      disabled={!editMode}
                      error={touched.title1 && Boolean(errors.title1)}
                      helperText={touched.title1 && errors.title1}
                      InputLabelProps={{ shrink: true }}
                    />
                    <Field
                      as={TextField}
                      name="title2"
                      label="Title 2"
                      variant="outlined"
                      size="small"
                      fullWidth
                      disabled={!editMode}
                      error={touched.title2 && Boolean(errors.title2)}
                      helperText={touched.title2 && errors.title2}
                      InputLabelProps={{ shrink: true }}
                    />
                    <Field
                      as={TextField}
                      name="description"
                      label="Description"
                      variant="outlined"
                      size="small"
                      fullWidth
                      disabled={!editMode}
                      error={touched.description && Boolean(errors.description)}
                      helperText={touched.description && errors.description}
                      InputLabelProps={{ shrink: true }}
                    />
                    <Field
                      as={TextField}
                      name="buttonText"
                      label="Button Text"
                      variant="outlined"
                      size="small"
                      fullWidth
                      disabled={!editMode}
                      error={touched.buttonText && Boolean(errors.buttonText)}
                      helperText={touched.buttonText && errors.buttonText}
                      InputLabelProps={{ shrink: true }}
                    />
                  </div>
                  <div className="mt-5 rounded-xl border border-gray-300 bg-white p-4 shadow-sm">
                    <h3 className="mb-4 text-lg font-semibold text-gray-800 ">
                      Company Details
                    </h3>
                    {values.companyDetails?.map((detail, index) => (
                      <div
                        key={index}
                        className="mb-4 space-y-4 rounded-xl border border-gray-200 p-4 "
                      >
                        <Field
                          as={TextField}
                          name={`companyDetails[${index}].title`}
                          label="Title"
                          variant="outlined"
                          size="small"
                          fullWidth
                          disabled={!editMode}
                          error={
                            touched.companyDetails?.[index]?.title &&
                            Boolean(errors.companyDetails?.[index]?.title)
                          }
                          helperText={
                            touched.companyDetails?.[index]?.title &&
                            errors.companyDetails?.[index]?.title
                          }
                          InputLabelProps={{ shrink: true }}
                        />
                        <Field
                          as={TextField}
                          name={`companyDetails[${index}].value`}
                          label="Value"
                          variant="outlined"
                          size="small"
                          fullWidth
                          disabled={!editMode}
                          error={
                            touched.companyDetails?.[index]?.value &&
                            Boolean(errors.companyDetails?.[index]?.value)
                          }
                          helperText={
                            touched.companyDetails?.[index]?.value &&
                            errors.companyDetails?.[index]?.value
                          }
                          InputLabelProps={{ shrink: true }}
                        />
                      </div>
                    ))}
                  </div>
                </Form>
              )}
            </Formik>
          </div>
          <div className="rounded-xl border border-gray-300 bg-white p-4 shadow-sm">
            <Formik
              enableReinitialize
              initialValues={initialValues2}
              validationSchema={validationSchema2}
              onSubmit={handleSubmitSection1}
            >
              {({ values, errors, touched, handleChange, resetForm }) => (
                <Form>
                  <div className="flex items-center justify-between">
                    <h3 className="mb-4 text-lg font-semibold text-gray-800">
                      Section 1
                    </h3>
                    {editSection1 ? (
                      <div className="flex items-center gap-3">
                        <button
                          type="submit"
                          className="text-sm font-medium text-blue-600 hover:text-blue-800"
                        >
                          Save Changes
                        </button>
                        <button
                          type="button"
                          onClick={() => {
                            setEditSection1(false);
                            resetForm();
                            setStory(res?.section1?.description || "");
                          }}
                          className="text-sm font-medium text-gray-500 hover:text-gray-700"
                        >
                          Cancel
                        </button>
                      </div>
                    ) : (
                      <GoPencil
                        className="hover:text-black h-5 w-5 cursor-pointer"
                        onClick={() => setEditSection1(true)}
                      />
                    )}
                  </div>
                  <div className="flex flex-col gap-y-4">
                    <TextField
                      label="Title 1"
                      variant="outlined"
                      size="small"
                      fullWidth
                      name="title"
                      value={values.title}
                      onChange={handleChange}
                      disabled={!editSection1}
                      error={touched.title && Boolean(errors.title)}
                      helperText={touched.title && errors.title}
                    />
                    <SunEditor
                      value={story}
                      setContents={story}
                      setDefaultStyle="font-family: inherit; font-size: 14px; line-height: 1.5;"
                      setOptions={{
                        height: "auto",
                        minHeight: "200px",

                        buttonList: [
                          ["undo", "redo"],
                          ["fontColor", "bold", "underline", "italic"],
                          ["font", "fontSize", "formatBlock"],
                          ["align", "list", "lineHeight"],
                        ],

                        toolbarContainer: "#toolbar",
                        showPathLabel: false,
                        resizingBar: false,
                      }}
                      onChange={(content) => {
                        setStory(content);
                      }}
                      disable={!editSection1}
                    />
                    {touched.policy && errors.policy && (
                      <p className="mt-1 text-sm text-red-500">
                        {errors.policy}
                      </p>
                    )}
                  </div>
                  <div className="mt-6 rounded-xl border border-gray-300 bg-white p-4 shadow-sm">
                    <div className="flex items-center justify-between">
                      <h3 className="mb-4 text-lg font-semibold text-gray-800">
                        Principles
                      </h3>
                    </div>
                    <div className="flex flex-col gap-y-4">
                      {values.principles.map((item, index) => (
                        <div
                          key={index}
                          className="mb-3 flex flex-col gap-y-4 rounded-xl border border-gray-300 bg-white p-4 shadow-sm"
                        >
                          <TextField
                            label={`Title ${index + 1}`}
                            variant="outlined"
                            size="small"
                            fullWidth
                            name={`principles[${index}].title`}
                            value={item.title}
                            onChange={handleChange}
                            disabled={!editSection1}
                            error={
                              touched.principles &&
                              touched.principles[index] &&
                              errors.principles &&
                              errors.principles[index] &&
                              Boolean(errors.principles[index].title)
                            }
                            helperText={
                              touched.principles &&
                              touched.principles[index] &&
                              errors.principles &&
                              errors.principles[index] &&
                              errors.principles[index].title
                            }
                          />
                          <div className="w-28 rounded-xl border border-gray-300 bg-white p-4 shadow-sm">
                            <div className="relative ">
                              <img
                                src={
                                  principleImages[index]?.preview ||
                                  `${item.imageUrl}`
                                }
                                alt="principle"
                                className="aspect-square rounded-lg border"
                              />
                              {editSection1 && (
                                <>
                                  <div
                                    className="bg-black absolute inset-0 flex cursor-pointer items-center justify-center rounded-lg bg-opacity-40 opacity-0 transition-opacity group-hover:opacity-100"
                                    onClick={() =>
                                      document
                                        .getElementById(`file-input-${index}`)
                                        .click()
                                    }
                                  >
                                    <GoPencil className="h-5 w-5 text-white" />
                                  </div>
                                  <input
                                    id={`file-input-${index}`}
                                    type="file"
                                    accept="image/*"
                                    className="hidden"
                                    onChange={(e) =>
                                      handleImageChange(e, index)
                                    }
                                  />
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
          <div className="mt-4 rounded-xl border border-gray-300 bg-white p-4 shadow-sm">
            <Formik
              initialValues={{
                title1: res.section2?.title1 || "",
                title2: res.section2?.title2 || "",
                description: res.section2?.description || "",
              }}
              validationSchema={Section2Schema}
              onSubmit={handleSubmit2}
              enableReinitialize
            >
              {({ values, handleChange, errors, touched, resetForm }) => (
                <Form className="flex flex-col gap-y-4">
                  <div className="mb-4 flex items-center justify-between">
                    <h3 className="text-lg font-semibold text-gray-800">
                      Section 2
                    </h3>
                    {isEditing ? (
                      <div className="flex items-center gap-3">
                        <button
                          type="submit"
                          className="text-sm font-medium text-blue-600 hover:text-blue-800"
                        >
                          Save Changes
                        </button>
                        <button
                          type="button"
                          onClick={() => {
                            setIsEditing(false);
                            resetForm();
                          }}
                          className="text-sm font-medium text-gray-500 hover:text-gray-700"
                        >
                          Cancel
                        </button>
                      </div>
                    ) : (
                      <GoPencil
                        className="hover:text-black h-5 w-5 cursor-pointer"
                        onClick={() => setIsEditing(true)}
                      />
                    )}
                  </div>
                  <TextField
                    label="Title 1"
                    name="title1"
                    value={values.title1}
                    onChange={handleChange}
                    disabled={!isEditing}
                    error={touched.title1 && Boolean(errors.title1)}
                    helperText={touched.title1 && errors.title1}
                    variant="outlined"
                    size="small"
                    slotProps={{ inputLabel: { shrink: true } }}
                  />
                  <TextField
                    label="Title 2"
                    name="title2"
                    value={values.title2}
                    onChange={handleChange}
                    disabled={!isEditing}
                    error={touched.title2 && Boolean(errors.title2)}
                    helperText={touched.title2 && errors.title2}
                    variant="outlined"
                    size="small"
                    slotProps={{ inputLabel: { shrink: true } }}
                  />
                  <TextField
                    label="Description"
                    name="description"
                    value={values.description}
                    onChange={handleChange}
                    disabled={!isEditing}
                    error={touched.description && Boolean(errors.description)}
                    helperText={touched.description && errors.description}
                    variant="outlined"
                    size="small"
                    multiline
                    slotProps={{ inputLabel: { shrink: true } }}
                  />
                  <div className="group relative w-80 rounded-xl border border-gray-300 bg-white p-4 shadow-sm">
                    {console.log(values, section2ImagePreview)}
                    <img
                      src={section2ImagePreview}
                      className="aspect-square w-full rounded-lg object-cover"
                      alt="Section 2"
                    />
                    {isEditing && (
                      <>
                        <div
                          className="bg-black opa absolute inset-0 flex cursor-pointer items-center justify-center rounded-lg bg-[#353935] bg-opacity-50  opacity-0 transition group-hover:opacity-100"
                          onClick={() => section2FileInputRef.current.click()}
                        >
                          <div className="borderpx-3 flex items-center gap-2 rounded-full py-1 text-white">
                            <GoPencil className="h-5 w-5" />
                          </div>
                        </div>
                        <input
                          type="file"
                          accept="image/*"
                          ref={section2FileInputRef}
                          onChange={handleSection2ImageChange}
                          className="hidden"
                        />
                      </>
                    )}
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      )}
    </>
  );
};

export default About;
